// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../shared/services/security';

const PipDetailsHeader = (props, context) =>
    <header className='pip-details-header'>
        <h2>{props.title}</h2>
        <div className='button-group'>
            {hasAccess(context.security, 'CLAIM', 'CLM_CLAIM_CREATE') &&
                <a
                    className='create-claim'
                    href={`#/claims/pip/non-tracked/new/${props.pipId}`}
                >
                    <FormattedMessage id='CREATE_CLAIM'/>
                </a>
            }
        </div>
    </header>;

PipDetailsHeader.displayName = 'PipDetailsHeader';
PipDetailsHeader.propTypes = {
    pipId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};
PipDetailsHeader.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default PipDetailsHeader;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-details-header.js